<div class="rs-welcome rs-enrollment-section">
  <div class="rs-enrollment-section__content" *ngIf="userProfile$ | async">
    <div class="rs-welcome__title">{{'welcome.title' | translate: getUserName(userProfile$ | async)}}</div>
    <div class="rs-welcome__subtitle">{{'welcome.subtitle' | translate}}</div>
    <rs-section-footer (accepted)="letsStart()" buttonText="{{'buttons.lets-start' | translate}}"></rs-section-footer>
  </div>
</div>
